import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { injectGlobal, ThemeProvider } from "styled-components";
import "./i18n";

import "bootstrap/scss/bootstrap.scss";
import "cwb-react/dist/cwb-react.css";

import Routes from "./Routes";
import Header from "./common/Header";
import CWBRTheme from "./theme/CWBRSTheme";
import { setBrowserLang } from "shared/helpers";

injectGlobal`
  * {
    font-family: 'Open Sans', sans-serif;
    color: #353B48;
    letter-spacing: normal;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
  }

  #app {
    height: 100%;
  }
`;

setBrowserLang();

render(
  <ThemeProvider theme={CWBRTheme}>
    <BrowserRouter>
      <>
        <Header />
        <Routes />
      </>
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById("app")
);

if (module.hot) {
  module.hot.accept();
}
